import styled from "styled-components";
import { errorColor } from "../../../../../../../../config/constants";

export const MainDiv = styled.div`
  margin: auto;
  padding: 16px;
  width: 600px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #fff;
  gap: 18px;
`;
export const Title = styled.p`
  color: #000;
  font-size: 16px;
  font-weight: 600;
`;
export const SelectDiv = styled.div`
  width: 310px;
  position: relative;
`;
export const ReasonInfo = styled.p`
  color: #808080;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
`;
export const Textarea = styled.textarea`
  padding: 10px;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 80px;
  max-height: 120px;
  border: ${({ error }) => `1px solid ${error ? errorColor : "#e6e6e6"}`};
  background-color: #e6e6e6;
  outline: none;
  border-radius: 5px;
  color: #808080;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
`;
export const ActionsDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const CancelButton = styled.button`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1.5px solid #26a9b6;
  color: #26a9b6;
  background-color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const SaveButton = styled.button`
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  background-color: ${({ background }) => background && background};
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
